'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _splitField = require('../components/split-field');
var _propTypes = require('prop-types');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
DOB.propTypes = {
  name: _propTypes.string,
  helpText: _propTypes.string,
  label: _propTypes.string
};
DOB.defaultProps = {
  name: 'dateOfBirth',
  helpText: null,
  label: 'Date of birth (dd/mm/yyyy)'
};
function DOB(props) {
  return _react2.default.createElement(_splitField.Date, {
    name: props.name,
    helpText: props.helpText,
    label: props.label
  });
}
exports.default = DOB;